import { render, staticRenderFns } from "./ad-product-target.vue?vue&type=template&id=1528175e&scoped=true&"
import script from "./ad-product-target.vue?vue&type=script&lang=js&"
export * from "./ad-product-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1528175e",
  null
  
)

export default component.exports